// src/hooks/useNotificationsSocket.js
import { useEffect, useMemo } from "react";
import { io as clientIO } from "socket.io-client";
import { useDispatch } from "react-redux";
import { addOne } from "../slices/notificationsSlice";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"; // ✅ backend

export default function useNotificationsSocket({ userId, token }) {
  const dispatch = useDispatch();

  const socket = useMemo(
    () =>
      clientIO(API_BASE, {
        withCredentials: true,
        transports: ["websocket"],   // faster + cors friendly
        auth: { token },             // optional if you rely on cookie
        path: "/socket.io/",         // default, explicit for clarity
      }),
    [token]
  );

  useEffect(() => {
    // debug
    socket.on("connect", () => console.log("[sock] connected", socket.id));
    socket.on("connect_error", (e) => console.warn("[sock] connect_error", e.message));

    return () => {
      socket.off("connect");
      socket.off("connect_error");
    };
  }, [socket]);

  useEffect(() => {
    if (!userId) return;

    // join user room
    socket.emit("join", { userId: String(userId) });

    const onNew = (n) => {
      dispatch(
        addOne({
          _id: n._id,
          name: n.title,
          action: n.body,
          time: new Date(n.createdAt || Date.now()).toLocaleString(),
          avatar: n.icon || "/icons/icon-192.png",
          unread: n.unread !== false,
          url: n.url || "/",
        })
      );
    };

    socket.on("NOTIF_NEW", onNew);

    return () => {
      socket.off("NOTIF_NEW", onNew);
      socket.disconnect();
    };
  }, [socket, userId, dispatch]);
}
